import Vue from 'vue'
import http from '@/utils/ajax'
import { BUSCLSPARAM_INIT_LOADING, BUSCLSPARAM_INIT_SUCCESS, BUSCLSPARAM_INIT_FAIL,
  BUSCLSPARAM_BUSCLSGRPLIST, BUSCLSPARAM_GLANCODELIST, BUSCLSPARAM_ACCUMTYPELIST, BUSCLSPARAM_TARIFFLIST, BUSCLSPARAM_VEHGRPLIST,
  BUSCLSPARAM_VEHUSGLIST } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

const state = {
  init: 0,
  initErr: [],
  menu: {},
  busClsGrpList: [],
  glanCodeList: [],
  accumTypeList: [],
  tariffList: [],
  vehGrpList: [],
  vehUsgList: []
}

const getters = {

}

const mutations = {
  [BUSCLSPARAM_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [BUSCLSPARAM_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [BUSCLSPARAM_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [BUSCLSPARAM_BUSCLSGRPLIST](state, data) {
    Vue.set(state, 'busClsGrpList', data)
  },
  [BUSCLSPARAM_GLANCODELIST](state, data) {
    Vue.set(state, 'glanCodeList', data)
  },
  [BUSCLSPARAM_ACCUMTYPELIST](state, data) {
    Vue.set(state, 'accumTypeList', data)
  },
  [BUSCLSPARAM_TARIFFLIST](state, data) {
    Vue.set(state, 'tariffList', data)
  },
  [BUSCLSPARAM_VEHGRPLIST](state, data) {
    Vue.set(state, 'vehGrpList', data)
  },
  [BUSCLSPARAM_VEHUSGLIST](state, data) {
    Vue.set(state, 'vehUsgList', data)
  }
}

const actions = {
  async busClsManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.busClsManagement
    commit(BUSCLSPARAM_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      let apiURL = commitResult.menu.getBusClsGrpList
      if (apiURL) {
        try {
          const result = await http.get(apiURL)
          commit(BUSCLSPARAM_BUSCLSGRPLIST, result.data.data.busClsGrpList)
        } catch (err) {
          throw err
        }
      }
      apiURL = commitResult.menu.getGlanCodeList
      if (apiURL) {
        try {
          const result = await http.get(apiURL)
          commit(BUSCLSPARAM_GLANCODELIST, result.data.data.glanCodeList)
        } catch (err) {
          throw err
        }
      }
      apiURL = commitResult.menu.getAccumTypeList
      if (apiURL) {
        try {
          const result = await http.get(apiURL)
          commit(BUSCLSPARAM_ACCUMTYPELIST, result.data.data.accumTypeList)
        } catch (err) {
          throw err
        }
      }
      apiURL = commitResult.menu.getTariffList
      if (apiURL) {
        try {
          const result = await http.get(apiURL)
          commit(BUSCLSPARAM_TARIFFLIST, result.data.data.tariffList)
        } catch (err) {
          throw err
        }
      }
      apiURL = commitResult.menu.getVehGrpList
      if (apiURL) {
        try {
          const result = await http.get(apiURL)
          commit(BUSCLSPARAM_VEHGRPLIST, result.data.data.vehGrpList)
        } catch (err) {
          throw err
        }
      }
      apiURL = commitResult.menu.getVehUsgList
      if (apiURL) {
        try {
          const result = await http.get(apiURL)
          commit(BUSCLSPARAM_VEHUSGLIST, result.data.data.vehUsgList)
        } catch (err) {
          throw err
        }
      }
      commit(BUSCLSPARAM_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(BUSCLSPARAM_INIT_FAIL, extractMessages(error))
    }
  }
}
export default {
  state,
  getters,
  mutations,
  actions
}
